import {
  PICKUP_STATUS,
  PICKUP_STATUS_BAR_PANEL_FILTERS,
} from '../../../modules/Dispatch/RouteExecution/constants';

export const NOTIFICATION_TYPES = {
  DRIVER_MESSAGE: 'driverMessage',
  TO_BE_REVIEWED_PICKUP: 'toBeReviewedPickup',
} as const;

export type NotificationType = (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES];

export const NAVIGATE_TO_TO_BE_REVIEWED_PICKUP_ON_GRID = 'navigateToToBeReviewedPickupOnGrid';

/** Status-bar panel filter values that mean no footer filter is active. */
export const DEFAULT_PANEL_FILTER_VALUES = [
  PICKUP_STATUS.allPickups,
  PICKUP_STATUS.unassigned,
] as const;

export { PICKUP_STATUS_BAR_PANEL_FILTERS };

export const DRIVER_MESSAGE_LIMITS = {
  messageTruncateLength: 40,
  truncateSeparator: '...',
} as const;

export const TOAST_NOTIFICATION_LIMITS = {
  maxVisible: 3,
  dismissMs: 3000,
} as const;

export const TOAST_NOTIFICATION_EVENTS = {
  showToastMessageNotification: 'showToastMessageNotification',
  showToastPickupReviewNotification: 'showToastPickupReviewNotification',
} as const;

export const NOTIFICATION_PANEL_FILTERS = {
  ALL: 'all',
  MESSAGES: 'messages',
  PICKUPS: 'pickups',
} as const;

export type NotificationPanelFilter =
  (typeof NOTIFICATION_PANEL_FILTERS)[keyof typeof NOTIFICATION_PANEL_FILTERS];
